import { Box, Container, Typography } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import RocketLaunchOutlinedIcon from "@mui/icons-material/RocketLaunchOutlined";

const VisionMission = () => {
  return (
    <Box sx={styles.section}>
      <Container maxWidth="xl">
        <Box sx={styles.grid}>
          <InfoCard
            icon={<VisibilityOutlinedIcon />}
            title="Our Vision"
            text="To become a globally trusted technology and digital transformation partner enabling enterprises to achieve sustainable growth through innovation, intelligent systems, and digital transformation."
          />

          <InfoCard
            icon={<RocketLaunchOutlinedIcon />}
            title="Our Mission"
            text="Deliver world-class SAP and enterprise solutions, simplify operations through automation, and empower organizations with intelligent technologies."
          />
        </Box>
      </Container>

      <Box sx={styles.glowOne} />
      <Box sx={styles.glowTwo} />
      <Box sx={styles.gridPattern} />
    </Box>
  );
};

const InfoCard = ({ icon, title, text }) => (
  <Box sx={styles.card}>
    <Box sx={styles.headerRow}>
      <Box sx={styles.iconWrap}>{icon}</Box>

      <Typography variant="h4" sx={styles.title}>
        {title}
      </Typography>
    </Box>

    <Typography sx={styles.text}>{text}</Typography>
  </Box>
);

const styles = {
  section: {
    position: "relative",
    overflow: "hidden",
    py: { xs: 4, md: 6 },
    // background:
    //   "linear-gradient(135deg, #020816 0%, #071525 45%, #082d63 100%)",
    background: "#071525",
    color: "#fff",
  },

  grid: {
    position: "relative",
    zIndex: 2,
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      md: "repeat(2, 1fr)",
    },
    gap: { xs: 3, md: 5 },
  },

  card: {
    position: "relative",
    p: { xs: 3, sm: 3.5, md: 4 },
    borderRadius: "28px",
    backdropFilter: "blur(18px)",
    transition: "all 0.4s ease",
    overflow: "hidden",

    // "&:hover": {
    //   transform: "translateY(-10px)",
    //   borderColor: "rgba(0,200,83,0.55)",
    //   boxShadow: "0 30px 90px rgba(0,200,83,0.18)",
    // },

    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      background:
        "linear-gradient(120deg, rgba(0,200,83,0.16), transparent 35%, rgba(255,255,255,0.08))",
      opacity: 0,
      transition: "0.4s ease",
    },

    "&:hover::before": {
      opacity: 1,
    },
  },

  headerRow: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    mb: 2.5,
    position: "relative",
    zIndex: 1,
  },

  iconWrap: {
    width: 54,
    height: 54,
    minWidth: 54,
    borderRadius: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background:
      "linear-gradient(135deg, rgba(0,200,83,0.25), rgba(0,140,255,0.2))",
    color: "#00c853",
    border: "1px solid rgba(0,200,83,0.35)",

    "& svg": {
      fontSize: 30,
    },
  },

  title: {
    fontWeight: 800,
    letterSpacing: "-1px",
    fontSize: { xs: "1rem", md: "1.25rem" },
    mb: 0,
  },

  text: {
    position: "relative",
    zIndex: 1,
    fontSize: { xs: "0.8rem", md: "1rem" },
    lineHeight: 1.75,
    color: "rgba(255,255,255,0.78)",
  },

  glowOne: {
    position: "absolute",
    width: 360,
    height: 360,
    borderRadius: "50%",
    background: "rgba(0,200,83,0.18)",
    filter: "blur(90px)",
    top: -120,
    left: -120,
    animation: "floatGlow 7s ease-in-out infinite",

    "@keyframes floatGlow": {
      "0%, 100%": { transform: "translate(0, 0)" },
      "50%": { transform: "translate(40px, 30px)" },
    },
  },

  glowTwo: {
    position: "absolute",
    width: 420,
    height: 420,
    borderRadius: "50%",
    background: "rgba(0,120,255,0.16)",
    filter: "blur(100px)",
    right: -160,
    bottom: -140,
    animation: "floatGlowTwo 8s ease-in-out infinite",

    "@keyframes floatGlowTwo": {
      "0%, 100%": { transform: "translate(0, 0)" },
      "50%": { transform: "translate(-35px, -25px)" },
    },
  },

  // gridPattern: {
  //   position: "absolute",
  //   inset: 0,
  //   opacity: 0.09,
  //   backgroundImage: `
  //     linear-gradient(rgba(255,255,255,0.35) 1px, transparent 1px),
  //     linear-gradient(90deg, rgba(255,255,255,0.35) 1px, transparent 1px)
  //   `,
  //   backgroundSize: "48px 48px",
  // },
};

export default VisionMission;
